import { GranteeBudgetCategory, GranteeBudgetCategoryMap, granteeBudgetCategoryMapping } from './backend/salesforce-maps/GranteeBudgetCategory'
export const mapGranteeBudgetCategories = (
  results: GranteeBudgetCategory[]
): GranteeBudgetCategoryMap => {
  const topLevel = {}
  const budgetCategoryMapping: GranteeBudgetCategoryMap = {
    en_CA: {
      revenues: {},
      expenses: {}
    },
    fr_CA: {
      revenues: {},
      expenses: {}
    }
  }
  for (let i = 0; i < results.length; i++) {
    if (results[i].parentCategory === null) {
      topLevel[results[i].id] = results[i]
      topLevel[results[i].id].category = granteeBudgetCategoryMapping[results[i].name]
      topLevel[results[i].id].children = []
    }
  }
  for (let i = 0; i < results.length; i++) {
    const result = results[i]
    const parentCategoryId = result.parentCategory

    if (parentCategoryId !== null && parentCategoryId !== undefined) {
      const parent = topLevel[parentCategoryId]

      if (
        parent?.category !== undefined &&
        (parent.category.lang === 'en_CA' || parent.category.lang === 'fr_CA') &&
        (parent.category.category === 'revenues' || parent.category.category === 'expenses')
      ) {
        budgetCategoryMapping[parent.category.lang][parent.category.category][result.name] = {
          id: result.id,
          order: result.order
        }
      }
    }
  }
  return budgetCategoryMapping
}
